// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartEndDate = createAction('[Fund Chart] Set end date', props());
